import { stripQueryAndHash } from '@ordo/faro'
import type { CapturedNetworkRequest, CaptureResult } from 'posthog-js'

const ABSOLUTE_URL = /^https?:\/\//i

function scrubUrlValues(bag: unknown): void {
  if (!bag || typeof bag !== 'object') {
    return
  }
  const record = bag as Record<string, unknown>
  for (const [key, value] of Object.entries(record)) {
    if (typeof value === 'string' && ABSOLUTE_URL.test(value)) {
      record[key] = stripQueryAndHash(value)
    }
  }
}

/**
 * PostHog `before_send`. Every absolute URL in an event's properties, and in
 * the person properties it sets, leaves the browser without its query or
 * fragment (`$current_url`, `$referrer`, `$initial_current_url`, ...): ordo's
 * set-password, accept-invite and pairing pages carry tokens in the query, and
 * the impersonation landing page carries a session in the fragment.
 */
export function scrubEventUrls(event: CaptureResult | null): CaptureResult | null {
  if (!event) {
    return event
  }
  scrubUrlValues(event.properties)
  scrubUrlValues(event.properties?.['$set'])
  scrubUrlValues(event.properties?.['$set_once'])
  scrubUrlValues(event.$set)
  scrubUrlValues(event.$set_once)
  return event
}

/** Session replay passes every page URL, and any captured request URL, through this hook. */
export function scrubReplayUrl(request: CapturedNetworkRequest): CapturedNetworkRequest {
  return request.name ? { ...request, name: stripQueryAndHash(request.name) } : request
}
